// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__68fzG","clickEffect":"styles_clickEffect__Xnq_5","pulse":"styles_pulse__239mP"};